import { connect } from 'react-redux';

import {
  actionCreateMarketingPromotion,
  actionDeleteMarketingPromotion,
  actionGetMarketingPromotionDetail,
  actionGetMarketingPromotionList,
  actionUpdateMarketingPromotion,
} from 'store/manager-promotion/actions';

import ManagerPromotion from './ManagerPromotion';

const mapStateToProps = (state) => ({
  isLoadingGetMarketingPromotionList:
    state.ManagerPromotion.isLoadingGetMarketingPromotionList,
  isLoadingCreateMarketingPromotion:
    state.ManagerPromotion.isLoadingCreateMarketingPromotion,
  isLoadingUpdateMarketingPromotion:
    state.ManagerPromotion.isLoadingUpdateMarketingPromotion,
  isLoadingGetMarketingPromotionDetail:
    state.ManagerPromotion.isLoadingGetMarketingPromotionDetail,
  isLoadingDeleteMarketingPromotion:
    state.ManagerPromotion.isLoadingDeleteMarketingPromotion,
  marketingPromotionList: state.ManagerPromotion.marketingPromotionList,
  marketingPromotionTotal: state.ManagerPromotion.marketingPromotionTotal,
  marketingPromotionDetail: state.ManagerPromotion.marketingPromotionDetail,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetMarketingPromotionList: (payload) =>
    dispatch(actionGetMarketingPromotionList(payload)),
  actionGetMarketingPromotionDetail: (payload) =>
    dispatch(actionGetMarketingPromotionDetail(payload)),
  actionCreateMarketingPromotion: (payload) =>
    dispatch(actionCreateMarketingPromotion(payload)),
  actionUpdateMarketingPromotion: (payload) =>
    dispatch(actionUpdateMarketingPromotion(payload)),
  actionDeleteMarketingPromotion: (payload) =>
    dispatch(actionDeleteMarketingPromotion(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerPromotion);
